<section class="section nearby-section">
  <div class="container">
    <div class="section-heading compact-heading">
      <h2>{{'landing.nearby.title'|traduccion}}</h2>
      <p>{{'landing.nearby.subtitle'|traduccion}}</p>
    </div>

    <div class="nearby-wrap">
      <div class="nearby-grid"
           [style.--desktop-columns]="balancedColumns(5)"
           [style.--tablet-columns]="balancedColumns(3)">
        @for (place of places; track place.id) {
          <article class="nearby-card">
            <span class="nearby-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" />
                <circle cx="12" cy="10" r="2.5" />
              </svg>
            </span>
            <div class="nearby-details">
              <h3>{{ place.name }}</h3>
              @if (walkingMinutes(place.walkingTime); as minutes) {
                <p>{{ 'landing.nearby.walking' | traduccion: { minutes: minutes } }}</p>
              }
            </div>
          </article>
        }
      </div>
    </div>
  </div>
</section>
